import { Button, Empty, Table } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import moment from 'moment';

function formatTime(value) {
    if (!value) return '';
    const local = moment.utc(value).local();
    if (!local.isValid()) return '';
    return local.format('YYYY-MM-DD HH:mm');
}

const columns = [
    { title: 'Barcode', dataIndex: 'barcode', width: 160, render: value => value || '—' },
    { title: 'SKU', dataIndex: 'skuName', width: 220, ellipsis: true, render: value => value || '—' },
    { title: 'Company', dataIndex: 'companyCode', width: 110 },
    { title: 'Product type', dataIndex: 'productType', width: 140, render: value => value || '—' },
    {
        title: 'Bays',
        dataIndex: 'bays',
        width: 220,
        render: bays => (bays || []).filter(Boolean).join(', ') || '—',
    },
    { title: 'Raw QC', dataIndex: 'rawQc', width: 110, render: value => value || '—' },
    {
        title: 'Shoot complete',
        dataIndex: 'shootCompletionTime',
        width: 160,
        render: value => formatTime(value) || '—',
    },
];

function excelRows(rows) {
    return rows.map(row => ({
        Barcode: row.barcode || '',
        SKU: row.skuName || '',
        Company: row.companyCode || '',
        'Product type': row.productType || '',
        Bays: (row.bays || []).filter(Boolean).join(', '),
        'Raw QC': row.rawQc || '',
        'Shoot complete': formatTime(row.shootCompletionTime),
    }));
}

export default function CompanySkuList({ rows, loading, fileName }) {
    const list = rows || [];
    const exportExcel = () => {
        const sheetRows = excelRows(list);
        const sheet = XLSX.utils.json_to_sheet(sheetRows.length ? sheetRows : [{ Note: 'No SKUs' }]);
        const buffer = XLSX.write({ Sheets: { SKUs: sheet }, SheetNames: ['SKUs'] }, { bookType: 'xlsx', type: 'array' });
        FileSaver.saveAs(
            new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
            `${fileName}.xlsx`
        );
    };

    return (
        <div className="company-sku-list">
            <div className="company-sku-list-bar">
                <span>{loading ? 'Loading…' : `${list.length} SKUs`}</span>
                <Button icon={<DownloadOutlined />} onClick={exportExcel} disabled={loading || !list.length}>
                    Export Excel
                </Button>
            </div>
            <Table
                rowKey="skuId"
                columns={columns}
                dataSource={list}
                loading={loading}
                size="small"
                pagination={{ pageSize: 50, showSizeChanger: false }}
                scroll={{ x: 1120 }}
                locale={{ emptyText: <Empty description="No SKUs" /> }}
            />
        </div>
    );
}
